<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-icon>fas fa-list</v-icon>
      <h2 class="title ml-2">Matutina</h2>
    </v-card-title>
    <v-card-text v-if="value">
      <p class="headline text-center mt-2">{{value.titulo}}</p>
      <p class="subtitle-2 text-center ma-0">Fecha: {{value.fecha}}</p>
      <blockquote class="blockquote" v-html="value.versiculo" />
      <p v-html="value.contenido" />
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="$emit('close')">
        <v-icon left>fas fa-times</v-icon>
        Cerrar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ['value']
}
</script>
